import {
  Field,
  FieldDescription,
  FieldError,
  FieldLabel,
} from "@/components/ui/field";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from "@/components/ui/input-group";
import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";
import type { ComponentProps } from "react";

interface ICustomInputProps extends ComponentProps<"input"> {
  label?: string;
  leftIcon?: LucideIcon;
  error?: string;
  helperText?: string;
  labelClassName?: string;
}

const CustomInput = ({
  id,
  label,
  leftIcon: LeftIcon,
  error,
  helperText,
  labelClassName,
  ...props
}: Readonly<ICustomInputProps>) => {
  return (
    <Field className="flex w-full flex-col gap-1">
      {label && (
        <FieldLabel htmlFor={id} className={cn("text-base", labelClassName)}>
          {label}
        </FieldLabel>
      )}
      <InputGroup className="has-[[data-slot][aria-invalid=true]]:animate-shake">
        <InputGroupInput id={id} aria-invalid={!!error} {...props} />
        {LeftIcon && (
          <InputGroupAddon>
            <LeftIcon color="#8e9097" />
          </InputGroupAddon>
        )}
      </InputGroup>
      {helperText && !error && (
        <FieldDescription className="text-xs">{helperText}</FieldDescription>
      )}

      {error && <FieldError className="text-start text-xs">{error}</FieldError>}
    </Field>
  );
};

export default CustomInput;
